import { render } from "./OrderDetailsGroup.vue?vue&type=template&id=e3a00436"
import script from "./OrderDetailsGroup.vue?vue&type=script&lang=js"
export * from "./OrderDetailsGroup.vue?vue&type=script&lang=js"

import "./OrderDetailsGroup.vue?vue&type=style&index=0&id=e3a00436&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__